export enum ENUM_PATHS {
  MAIN = "/",
  MAIN_BLOGGER = "/blogger",
  PROFILE = "/profile",
  NOT_FOUND = "/*",
  CATALOG = "/catalog",
  CART = "/cart",
  TURNKEY = "/turnkey",
  WALLET = "/wallet",
  DOCUMENTS = "/documents",
  WALLET_TOP_UP = "/wallet/topup",
  WALLET_WITHDRAW = "/wallet/withdraw",
  WALLET_HISTORY = "/wallet/history",
  CREATE_ORDER = "/createorder",
  ADD_CHANNEL = "/addchannel",
  ADD_LEGAL = "/addLegal",
  FULL_SERVICE = "/fullService",
  ORDERS = "/orders",
  PROJECT_PAGE = "/project/:project_id",
  PROJECT_REPORT = "/project/:project_id/report",
  GUIDE = "/guide/:guide_id",
  OFFERS = "/offers",
  TRACK_ORDERS = "/track-orders",
  MY_CHANNELS = "/channels",
  CHANNEL = "/channel/:id",
  FAQ = "/faq",
  LOGIN = "/login",
  OAUTH_CALLBACK = "/oauth-callback",
  REGISTRATION = "/registration",
  SERVICE_RULES = "/service_rules",
  PUBLIC_OFFER = "/public_offer",
  POST_TEMPLATES = "/post_templates",
  ADMIN_HOME = "/admin/home",
  ADMIN_ORGANIZATION = "/admin/organization",
  ADMIN_ACCOUNTING = "/admin/accounting",
  ADMIN_CHANNELS = "/admin/channels",
  ADMIN_USERS = "/admin/users",
  ADMIN_USER_INFO = "/admin/users/:id",
  ADMIN_USER_GROUPS = "/admin/user-groups",
  ADMIN_USER_GROUP_INFO = "/admin/user-groups/:id",
  ADMIN_TRANSACTIONS = "/admin/transactions",
  ADMIN_REVIEWS = "/admin/reviews",
  ADMIN_COMPLAINTS = "/admin/complaints",
  ADMIN_COMPLAINT_INFO = "/admin/complaints/:id",
  ADMIN_DOCUMENTS = "/admin/documents",
  ADMIN_ORDER_TRANSFER = "/admin/order-transfer",
  ADMIN_TRACK_ORDERS = "/admin/track-orders",
  ADMIN_COMMON_OBSERVE = "/admin/common-observe",
  ADMIN_MAILING = "/admin/mailing",
  ADMIN_CHANNEL_OWNER_SWAP = "/admin/channel-owner-swap",
  ADMIN_ORDER_UPDATE = "/admin/order-update",
  ADMIN_ORDER_PUBLISH = "/admin/order-publish",
  ADMIN_PROJECT_COMPLETE = "/admin/project-complete",
  ADMIN_MANAGE_PROJECTS = "/admin/manage-projects",
  ADMIN_DELETE_ORGANIZATION = "/admin/delete-organization",
}
